import Widget from "../../Widget";
import IntlMessages from "../../../util/IntlMessages";

const Page = ({ children,styleName}) => {
    
    return (
      <Widget styleName={styleName}>
        {children}
      </Widget>
    )
  };
  
  export default Page;
